import { Outlet } from 'react-router-dom'
import { AuthenticatedLayoutNav } from '@/layouts/AuthenticatedLayoutNav'
import { AuthenticatedLayoutFooter } from '@/layouts/AuthenticatedLayoutFooter'
import { ActingAsBanner } from '@/components/ActingAsBanner'
import { PrefetchOcWorkflowSettings } from '@/features/order-confirmation/components/PrefetchOcWorkflowSettings'

export function AuthenticatedLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <PrefetchOcWorkflowSettings />
      <AuthenticatedLayoutNav />
      <div className="flex-grow pt-16">
        <ActingAsBanner />
        <Outlet />
      </div>
      <AuthenticatedLayoutFooter />
    </div>
  )
}
